import { render, staticRenderFns } from "./RemitosConfirmar.vue?vue&type=template&id=4a985950&scoped=true&"
import script from "./RemitosConfirmar.vue?vue&type=script&lang=js&"
export * from "./RemitosConfirmar.vue?vue&type=script&lang=js&"
import style0 from "./RemitosConfirmar.vue?vue&type=style&index=0&id=4a985950&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a985950",
  null
  
)

export default component.exports